
const { ccclass, property } = cc._decorator;

@ccclass("SlotAnim")
export class SlotAnim {

    @property(cc.String)
    key: string = ""
    @property(dragonBones.ArmatureDisplay)
    dragon: dragonBones.ArmatureDisplay = null
    @property(cc.Animation)
    anim: cc.Animation = null
}

@ccclass
export class AnimHolderSlot extends cc.Component {
    @property(SlotAnim)
    anims: SlotAnim[] = [];

    getAnimByName(key) {
        for (let idx = 0; idx < this.anims.length; idx++) {
            let anim = this.anims[idx];
            if (anim.key == key) {
                return anim.anim
            }
        }
        return null;
    }
    getGragonByName(key) {
        for (let idx = 0; idx < this.anims.length; idx++) {
            let anim = this.anims[idx];
            if (anim.key == key) {
                return anim.dragon
            }
        }
        return null;
    }
}
